export default __webpack_public_path__ + "static/tv-show-8-0c85522a6ba30fd7225e1f49fef09204.jpg";